import React from 'react';
import { findIndex } from 'lodash';
import $ from 'jquery';
import moment from 'moment';

import {
  Modal,
  Button,
  FormControl,
  FormGroup,
  ControlLabel,
  Col,
  Row,
  Well
} from 'react-bootstrap';

import PagerUd from '../../../commonComponents/PagerUd';
import DeleteBtnWithConfirm from '../../../commonComponents/DeleteBtnWithConfirm';

import { FileDropAreaCt } from '../../../commonComponents/FileDropAreaCt';
import { onFileDrop, onFileDelete } from '../../../commonComponents/onFileModify';
import { DataListWrapper } from '../../../commonComponents/DataTable/DataTablePs';
import DropDownMenu, { optsGeneratorCommon } from '../../../commonComponents/DropDownMenu';
import { dateDivider } from '../../../commonComponents/FullDatePicker';
import DayPicker from '../../../commonComponents/DayPicker';
import ShippingListCt from './ShippingListCt';


import custJqAjax from '../../../commonJS/custJqAjax';
// import autoFill from '../../../commonJS/autoFill';
import parentStateHandler from '../../../commonJS/parentStateHandler';
import { textInputOnChange, dateOnChange, dropDownOnChange } from '../../../commonJS/onFormChanges';
import { dateFormatCutter } from '../../../commonJS/formatters';
import inputValidation from '../../../commonJS/inputValidation';
import removeCommasToNumber from '../../../commonJS/removeCommasToNumber';
import { numberHandler } from '../../../commonJS/addCommasToNumber';


export default class SalesCasesModalCt extends React.PureComponent {
  constructor(props) {
    super(props);

    this.handlers = {
      textInputOnChange: e => {
        // 特定欄位檢查是否為數字，若否則傳回原值
        let cb;
        switch (e.currentTarget.id) {
          case 'activeDays':
          case 'expectedPrice':
            cb = (id, value) => {
              // 清空內容的情況處理
              if (value === '') return value;
              // 非空內容清況處理
              // 移除千分位
              let inProcessValue = removeCommasToNumber(value, 1);
              // 檢查是否為數字
              inProcessValue = inputValidation(inProcessValue, { numberTest: true }).numberTest ? inProcessValue : this.state[e.currentTarget.id];
              // 加上千分位並轉為文字
              return numberHandler(inProcessValue);
            };
            break;
          default:

        }

        textInputOnChange(e, this, cb);
      },
      dateOnChange: (selection, stateName, dateStateNames, dateStateValues) => {
        this.setState(dateOnChange(selection, stateName, dateStateNames, dateStateValues));
      },
      dropDownOnChange: (selection, stateName) => {

        const obj = dropDownOnChange(selection, stateName);
        switch (stateName) {
          case 'companyId':
            // obj.address = selection.address.street;
            obj.dpmName = '';
            obj.tel = selection.telephone;
            obj.fax = selection.fax || '';
            obj.mobilePhone = '';
            obj.email = selection.service_email;
            this.variables.companyName = selection.label;
            this.funcs.loadOptsContact(selection.id);
            obj.contactId = '';
            break;
          case 'contactId':
            obj.dpmName = selection.unit;
            obj.tel = selection.work_phone;
            obj.fax = selection.fax || '';
            obj.mobilePhone = selection.cell_phone;
            obj.email = selection.email;
            this.variables.contactName = selection.label;
            break;
          // case 'modelId':
          //   this.variables.modelName = selection.label;
          //   break;
          case 'currentStatus':
            obj.currentStatusName = selection.label;
            break;
          case 'probability':
            obj.probabilityName = selection.label;
            break;
          case 'caseType':
            obj.caseTypeName = selection.label;
            break;
          case 'purchaseStatus':
            obj.purchaseStatusName = selection.label;
            break;
          default:

        }

        this.setState(obj);
      },
      // onInputFocus: e => {
      //   autoFill(e, this);
      // },
      saveItem: isUpdate => {
        const state = this.state,
          props = this.props,
          id = isUpdate ? (props.selectedItemId || props.params.caseId) : "";
        // tw_data_list = `${state.price_tw}|${state.delivery_tw}|${state.characteristics_tw}|${state.appliance_tw}`,
        // en_data_list = `${state.price_en}|${state.delivery_en}|${state.characteristics_en}|${state.appliance_en}`,
        // cn_data_list = `${state.price_cn}|${state.delivery_cn}|${state.characteristics_cn}|${state.appliance_cn}`,
        // ja_data_list = `${state.price_jp}|${state.delivery_jp}|${state.characteristics_jp}|${state.appliance_jp}`; 

        let formData = new FormData();

        // 應急配合api，應只需id不需name…
        const companyInd = findIndex(props.optsCompany, { id: state.companyId }),
          companyName = companyInd === -1 ? "" : props.optsCompany[companyInd].name;

        // 日期處理
        if (state.quoteDay) {
          formData.append('case_quoteday', state.quoteDay.format("YYYY-MM-DD"));
        }

        if (state.dealDay) {
          formData.append('case_dealday', state.dealDay.format("YYYY-MM-DD"));
        }

        if (state.remindDay) {
          formData.append('case_reminder_date', state.remindDay.format("YYYY-MM-DD"));
        }

        formData.append('case_owner', props.userId);
        formData.append('case_createdate', state.caseCreateDate.format("YYYY-MM-DD"));
        formData.append('company_id', state.companyId);
        formData.append('company_name', companyName);
        formData.append('group_name', state.dpmName);
        formData.append('contact_id', state.contactId);
        formData.append('contact_name', this.variables.contactName);
        formData.append('address', state.address);
        formData.append('work_phone', state.tel);
        // formData.append('ext', state.ext);
        formData.append('cell_phone', state.mobilePhone);
        formData.append('fax', state.fax);
        formData.append('email', state.email);
        formData.append('case_stage', state.currentStatus);
        formData.append('case_type', state.caseType);
        formData.append('case_closerate', state.probability);
        formData.append('case_source', state.cusSource);
        formData.append('case_validly', removeCommasToNumber(state.activeDays));
        formData.append('case_payment', state.paymentType);
        formData.append('case_units', state.caseCurrency);
        formData.append('case_dealprice', removeCommasToNumber(state.expectedPrice));
        // formData.append('case_units', state.deliveryNumber);
        // formData.append('case_exchange', state.deliveryNumber);
        formData.append('case_periodicity', state.remindPeriod);
        formData.append('case_buyissue', state.purchaseStatus);
        formData.append('case_competitor', state.competitor);
        formData.append('case_product_description', state.caseProductDescription);
        formData.append('case_strategy', state.negotiation);
        formData.append('case_remark', state.notes);
        // formData.append('product_id', state.deliveryNumber);
        // formData.append('case_product', state.deliveryNumber);
        // formData.append('case_product_unit', state.deliveryNumber);
        // formData.append('case_products_spec', state.deliveryNumber);
        // formData.append('case_product_price', state.deliveryNumber);


        // formData.append('delivery_number', state.deliveryNumber);
        // formData.append('order_number', state.orderNumber);
        // formData.append('company_id', state.companyId);
        // formData.append('company_name', this.variables.companyName);
        // formData.append('contact_id', state.contactId);
        // formData.append('contact_Name', this.variables.contactName);
        // formData.append('address', state.address);
        // formData.append('tel', state.tel);
        // formData.append('fax', state.fax);
        // formData.append('model_id', state.modelId);
        // formData.append('model_name', this.variables.modelName);
        // formData.append('serial_number', state.serialNumber);
        // formData.append('amount', state.amount);
        // formData.append('bom_number', state.bomNumber);
        // formData.append('notes', state.notes);

        // if (state.deliveryDay) {
        //   formData.append('delivery_date', dateFormatter(state.deliveryDay, state.deliveryHour, state.deliveryMinute));
        // }

        // if (state.arrivalDay) {
        //   formData.append('arrival_date', dateFormatter(state.arrivalDay, state.arrivalHour, state.arrivalMinute));
        // }

        // if (state.installDay) {
        //   formData.append('install_date', dateFormatter(state.installDay, state.installHour, state.installMinute));
        // }

        // if (state.warrantyDay) {
        //   formData.append('warranty_date', dateFormatter(state.warrantyDay, state.warrantyHour, state.warrantyMinute));
        // }


        if (isUpdate) {
          formData.append('sales_case_id', id);
        } else {
          // 修改者不一定是建立者，需要的是建立者的 group id，所以新增時才設定 group id
          formData.append('group_id', props.propsPackageFromSkyFamily.groupId);
        }

        custJqAjax({
          type: 'POST',
          url: `/api/M_Sales_Case_Data_${isUpdate ? 'Update' : 'Post'}.php`,
          data: formData,
          processData: false,
          contentType: false,
          success: res => {
            const resId = res.result.sales_case_id;

            this.handlers.onItemModified(res.result, isUpdate ? 'update' : 'create');

            // 修正選pack時若無既存選配會出錯問題

            // 新增時將項目設定為選中項目
            let extraStates = [], extraValues = [], isNew;

            if (this.props.router) {
              // 一般新增
              if (!this.props.params || !this.props.params.caseId || this.state.editMode === 'Copy') {
                extraStates = ['selectedRowIndex', 'selectedItemId'];
                extraValues = [0, resId];
                isNew = true;
              }
            } else {
              // 客戶資訊底下新增
              if (!this.props.selectedItemId || this.state.editMode === 'Copy') {
                extraStates = ['selectedRowIndex', 'selectedItemId'];
                extraValues = [0, resId];
                isNew = true;
              }
            }


            // 處理update的檔案刪除動作
            if (isUpdate) this.fileWorker(undefined, resId, isNew);

            // 處理上傳檔案
            this.fileWorker(true, resId, isNew);


            // 如果完全沒有執行檔案相關作業，會需要從這裡關閉
            if (this.filesWip < 1) {

              // 新增情境時routing
              if (isNew) {
                // 在客戶資訊底下不會有router傳入
                if (this.props.router) {
                  this.props.router.replace(`/salesky/sales-cases/${resId}`);
                }

                if (this.state.editMode === 'Copy') {
                  this.setState({
                    editMode: 'View',
                    onCopy: false
                  });
                }
              } else {
                props.closeModal();
              }

            }

            // 更新搜尋結果並將新增項目設定為選中項目
            props.parentStateHandler({ states: ['doSearchUpdate', ...extraStates], newValues: [1, ...extraValues] });
          }
        });
      },
      deleteItem: () => {
        let formData = new FormData(),
          id = this.props.selectedItemId;


        formData.append('sales_case_id', id);

        custJqAjax({
          type: 'POST',
          url: '/api/M_Sales_Case_Data_Delete.php',
          data: formData,
          processData: false,
          contentType: false,
          success: data => {
            const itemInd = findIndex(this.props.sortedData._data, { sales_case_id: id });

            this.handlers.onItemModified({ itemInd }, 'delete');
            this.props.closeModal({ isDeletion: true });
            this.props.parentStateHandler({ states: 'doSearchUpdate', newValues: 1 });
          }
        });
      },
      onItemModified: (data, mode) => {

        // 更新sortedData
        const sales_case_id = data.sales_case_id,
          newItem = (mode === 'delete') ? '' : {
            // 時間格式預處理
            ...dateFormatCutter(data, ['case_createdate', 'case_quoteday', 'case_reminder_date', 'case_dealday']),
            // company_name: this.variables.companyName,
            // contact_name: this.variables.contactName,
            // model_name: this.variables.modelName
          };

        let sortedData = this.props.sortedData;


        if (mode === "create") {
          const len = sortedData._data.length,
            // 加上 name
            obj = {
              ...newItem,
              caseStatusName: this.state.currentStatusName,
              caseTypeName: this.state.caseTypeName,
              caseProbabilityName: this.state.probabilityName,
              casePurchmentStatusName: this.state.purchaseStatusName
            };

          sortedData._data.push(obj);
          // 新增的資料預設排在最前面
          sortedData._indexMap.unshift(len);
        } else if (mode === "update") {
          const updateInd = findIndex(sortedData._data, { sales_case_id }),
            // 更新 name
            oldObj = sortedData._data[updateInd],
            obj = {
              ...newItem,
              caseStatusName: this.state.currentStatusName || oldObj.caseStatusName,
              caseTypeName: this.state.caseTypeName || oldObj.caseTypeName,
              caseProbabilityName: this.state.probabilityName || oldObj.caseProbabilityName,
              casePurchmentStatusName: this.state.purchaseStatusName || oldObj.casePurchmentStatusName
            };

          sortedData._data[updateInd] = obj;
        } else if (mode === "delete") {
          // let updateInd = findIndex(sortedData._data, {delivery_number});
          // 從indexMap中移除索引即可，不需從_data中移除資料
          // 確保為完整資料map而非搜尋篩選過的map
          sortedData._data[data.itemInd].exception = true;
          const mapInd = sortedData._indexMap.indexOf(data.itemInd);
          sortedData._indexMap.splice(mapInd, 1);
        }

        // 雖然是相同的_data與_index資料，但owner 物件為新的，符合pure component需求
        sortedData = new DataListWrapper(sortedData._indexMap, sortedData._data, 'company_id');

        this.props.stateHandler({ states: 'salesCasesSortedData', newValues: sortedData });

      },
      getValidationState: value => (value === 'default' || !value) ? 'error' : null,
      onEditClick: () => { this.setState({ onEdit: true, onCopy: false, editMode: "Edit" }) },
      onCopyClick: () => {
        // 重置
        // this.fileSorts = {
        //   img: [],
        //   pdf: [],
        //   video: []
        // };

        this.setState({
          // set mode
          onCopy: true, onEdit: false, editMode: "Copy",
          // clear partId
          // partId: '',
          // clear shipping list
          shippingList: { loaded: true, data: [] },
          // clear files
          downloadedFiles: [],
          downloadedImgs: [],
          downloadedPDFs: [],
          downloadedVideos: [],
          previewsImg: [],
          previewsPDF: [],
          previewsVideo: []
        }, () => {
          // document.getElementById('deliveryNumber').focus();
        });

      },
      loadItemData: (id, uploadToDownload) => {
        custJqAjax({
          type: 'GET',
          ajaxsWip: this.ajaxsWip,
          custId: this.props.propsPackageFromSkyFamily.jqAjaxIdGenerator.getId(),
          url: `/api/M_Sales_Case_Data_Get.php?sales_case_id=${id}`,
          processData: false,
          contentType: false,
          success: res => {
            if (!res.result.sales_case_id) return;
            const data = res.result,
              orinFiles = data.images.concat(data.pdfs).concat(data.videos),
              downloadedFiles = this.fileFilter(orinFiles);

            if (!uploadToDownload) {
              const case_createdate = dateDivider(data.case_createdate),
                case_quoteday = dateDivider(data.case_quoteday),
                case_reminder_date = dateDivider(data.case_reminder_date),
                case_dealDay = dateDivider(data.case_dealday);

              this.variables.companyName = data.company_name;
              this.variables.contactName = data.contact_name;
              this.variables.modelName = data.model_name;

              this.setState({
                caseCreateDate: case_createdate.day,
                quoteDay: case_quoteday.day,
                dealDay: case_dealDay.day,
                companyId: data.company_id,
                // dpmId: data.group_id,
                dpmName: data.group_name,
                contactId: data.contact_id,
                address: data.address,
                tel: data.work_phone,
                fax: data.fax,
                mobilePhone: data.cell_phone,
                email: data.email,
                currentStatus: data.case_stage,
                probability: data.case_closerate,
                cusSource: data.case_source,
                caseType: data.case_type,
                remindDay: case_reminder_date.day,
                remindPeriod: data.case_periodicity,
                expectedPrice: numberHandler(data.case_dealprice),
                activeDays: numberHandler(data.case_validly),
                purchaseStatus: data.case_buyissue,
                paymentType: data.case_payment,
                caseCurrency: data.case_units,
                caseProductDescription: data.case_product_description,
                negotiation: data.case_strategy,
                competitor: data.case_competitor,
                notes: data.case_remark,
                case_owner_name: data.case_owner_name
              });

              this.funcs.loadOptsContact(data.company_id);
            }

            // for downloaded files that uploaded before
            this.onFileDrop(downloadedFiles);
          }
        });
      },
      rowIndexCheck: passUpdate => {
        // 預防使用者在modal重新整理，導致無selectedRowIndex，造成上一筆下一筆功能異常
        if (this.props.params &&
          this.props.params.caseId &&
          !this.props.selectedRowIndex &&
          this.props.selectedRowIndex !== 0) {

          // 初始狀態的ind和indexMap是一樣的

          let itemId = this.props.params.caseId,
            ind = findIndex(this.props.filteredSortedData._data, { sales_case_id: itemId });

          if (!passUpdate) {
            this.props.parentStateHandler({
              states: ['selectedItemId', 'selectedRowIndex'],
              newValues: [itemId, ind]
            });
          }

          return ind;
        }
        return this.props.selectedRowIndex;
      },
      changeItem: () => {
        const id = this.props.selectedItemId || this.props.params.caseId;

        this.handlers.loadItemData(id);
        this.funcs.loadShippingList(id);
      },
      onPreviousClick: () => {
        let selectedRowIndex = this.handlers.rowIndexCheck(),
          r = (selectedRowIndex - 1),
          rowIndex = r >= 0 ? r : 0;
        if (rowIndex !== selectedRowIndex) {
          // let id = this.props.productSortedData.getObjectAt(rowIndex).id;
          this.props.onRowClick("e", rowIndex, this.props.filteredSortedData);
          // this.handlers.loadItemData(id);

          // load new Product
          this.funcs.resetState(this.handlers.changeItem);
        }
      },
      onNextClick: () => {
        let selectedRowIndex = this.handlers.rowIndexCheck(),
          r = (selectedRowIndex + 1),
          filteredSortedData = this.props.filteredSortedData,
          max = filteredSortedData.getSize(),
          rowIndex = r < max ? r : (max - 1);
        if (rowIndex !== selectedRowIndex) {
          // let id = productSortedData.getObjectAt(rowIndex).id;
          this.props.onRowClick("e", rowIndex, filteredSortedData);
          // this.handlers.loadItemData(id);

          // load new Product
          this.funcs.resetState(this.handlers.changeItem);
        }
      }
    };

    this.variables = {
      companyName: '',
      contactName: '',
      modelName: ''
    };

    this.funcs = {
      resetState: cb => {

        this.uploadedFiles = [];

        this.setState({
          // 正式 ===
          case_owner_name: '',
          caseCreateDate: moment(),
          quoteDay: null,
          companyId: '',
          // dpmId: '',
          dpmName: '',
          contactId: '',
          address: '',
          tel: '',
          fax: '',
          mobilePhone: '',
          email: '',
          currentStatus: '',
          probability: '',
          cusSource: '',
          caseType: '',
          remindDay: null,
          remindPeriod: '',
          expectedPrice: '',
          activeDays: 30,
          purchaseStatus: '',
          paymentType: '',
          negotiation: '',
          competitor: '',
          notes: '',
          // ===
          // item
          // itemId: '',
          // itemName: '',
          // deliveryNumber: '',
          orderNumber: '',
          deliveryDay: null,
          deliveryHour: '',
          deliveryMinute: '',
          arrivalDay: null,
          arrivalHour: '',
          arrivalMinute: '',
          installDay: null,
          installHour: '',
          installMinute: '',
          warrantyDay: null,
          warrantyHour: '',
          warrantyMinute: '',
          optsContact: [],
          modelId: '',
          modelName: '',
          serialNumber: '',
          amount: '',
          bomNumber: '',
          // shipping list
          shippingList: { loaded: false, data: [] },
          // file crud 相關 ====================
          downloadedFiles: [],
          downloadedImgs: [],
          downloadedPDFs: [],
          downloadedVideos: [],
          previewsImg: [],
          previewsPDF: [],
          previewsVideo: [],
          deletedDownloadedFiles: [],
          fileWorkInProgress: false, // 控制檔案上傳進度用
          forceUpdate: true,
          clearUploadedFileLocal: false,
          // ====================
          // common
          btnSaveDisable: true,
          btnDeleteDisable: true,
          onEdit: false,
          onCopy: false,
          editMode: "View"
        }, cb ? cb : "");
      },
      loadShippingList: id => {
        custJqAjax({
          type: 'GET',
          ajaxsWip: this.ajaxsWip,
          custId: this.props.propsPackageFromSkyFamily.jqAjaxIdGenerator.getId(),
          url: `/api/W_ServiceSky_Delivery_Order_Detail_Get.php?delivery_number=${id}`,
          processData: false,
          contentType: false,
          complete: res => {
            let shippingList = { loaded: true, data: [] };

            if (res.responseJSON.status === '0') {
              shippingList.data = res.responseJSON.result;
            }

            // shippingList.data = [{
            //   id: '1', part_id: '1', part_name: '2', part_spec: '3',
            //   useage: '', unit: '', process: '', supplier_name: '', notes: ''
            // }];

            this.setState({ shippingList });
          }
        });
      },
      loadOptsContact: (companyId) => {
        custJqAjax({
          type: 'GET',
          ajaxsWip: this.ajaxsWip,
          custId: this.props.propsPackageFromSkyFamily.jqAjaxIdGenerator.getId(),
          url: `/api/W_SaleSky_Contacts.php?company_id=${companyId}`,
          processData: false,
          contentType: false,
          complete: res => {
            if (res.responseJSON.status === '404') {
              return;
            }

            const data = res.responseJSON.result,
              optsContact = optsGeneratorCommon(data, ['value', 'label'], ['id', 'name'], 1);

            this.setState({ optsContact });
          }
        });
      },
      loadOptsModel: () => {
        custJqAjax({
          type: 'GET',
          ajaxsWip: this.ajaxsWip,
          custId: this.props.propsPackageFromSkyFamily.jqAjaxIdGenerator.getId(),
          url: '/api/M_SaleSky_Product_Get.php',
          success: res => {
            let data = res.result, len = data.length, defaultSortIndexes = [],
              sortedData = [];

            for (let i = 0; i < len; i++) {
              defaultSortIndexes.push(i);
            }

            sortedData = new DataListWrapper(defaultSortIndexes, data, 'company_id');

            this.props.grandStateHandler({
              states: ['productOrinData', 'productSortedData', 'productDefaultSortIndexes'],
              newValues: [data, sortedData, defaultSortIndexes]
            });

            this.props.parentStateHandler({
              states: 'optsModel',
              newValues: optsGeneratorCommon(data, ['value', 'label'], ['id', 'name'])
            });

          }
        });
      },
      setDefaultCompany: optsCompany => {
        if (this.state.companyId) return;

        const customerCompanyId = this.props.customerCompanyId;

        if (customerCompanyId) {
          if (optsCompany.length !== 0) {
            const simSelection = optsCompany[findIndex(optsCompany, { id: customerCompanyId })];
            this.handlers.dropDownOnChange(simSelection, 'companyId')
          }
        }
      }
    };

    this.parentStateHandler = ({ states, newValues }) => {
      parentStateHandler({ states, newValues, parentThis: this });
    };

    this.ajaxsWip = [];

    // file crud相關 ===========
    // for file upload，不需渲染的資料不使用state，避免多餘的render check
    this.uploadedFiles = [];
    // this.fileSorts = {
    //   img: [],
    //   pdf: [],
    //   video: []
    // };

    // this.updateFilesSort = (objSortedNameURL, productId) => {
    //   // 更新檔案排序
    //   let postData = new FormData();
    //   postData.append('id', productId);
    //   postData.append('type', 'Product');

    //   postData.append('file_id_list', getFileIdList(objSortedNameURL).join());

    //   custJqAjax({
    //     type: 'POST',
    //     url: '/api/W_SkyFamily_System_Extra_Files_Sort_Update.php',
    //     data: postData,
    //     processData: false,
    //     contentType: false,
    //     complete: () => {}
    //   });

    // };

    // for downloaded files that uploaded before
    this.onFileDrop = downloadedFiles => {
      onFileDrop(downloadedFiles, '', this, true, false, false, this.fileSorts, this.parentStateHandler);
    };

    this.onFileDelete = (type, fileName) => {
      // onFileDelete是在onFileDrop裡面會被使用，
      // type, fileName在裡面預設會傳入

      // 編輯模式下remove icon才有效
      let itemId = "";
      if (this.props.params || this.props.selectedItemId) {
        itemId = this.props.selectedItemId || this.props.params.caseId;
      }

      if (this.state.editMode !== "View" || !itemId) {
        onFileDelete(type, fileName, this, true);
      } else {
        return;
      }

    };

    // 配合api
    this.fileFilter = orinFiles => {
      // 檔案預處理
      let name = "", dotInd = "", type = "";

      const downloadedFiles = orinFiles.map((item, ind) => {
        name = item.file_name;
        dotInd = name.lastIndexOf('.');
        type = name.slice(dotInd + 1);

        switch (type) {
          case 'jpg':
            item.type = 'image/jpeg';
            break;
          case 'png':
            item.type = 'image/png';
            break;
          case 'svg':
            item.type = 'image/svg+xml';
            break;
          case 'pdf':
            item.type = 'application/pdf';
            break;
          case 'mp4':
            item.type = 'video/mp4';
            break;
          default:
        }

        return item;

      });

      return downloadedFiles;
    };

    this.fileWorker = (isUpload, fileId, isNew) => {
      let fileData = new FormData(),
        requiredField = 'file_id',
        apiType = 'W',
        apiKeyWord = 'Upload_Delete',
        len = this.state.deletedDownloadedFiles.length;

      if (isUpload) {
        requiredField = '$_FILES';
        apiType = 'W';
        apiKeyWord = 'Upload_Post';
        len = this.uploadedFiles.length;
        fileData.append('file_id', fileId);
      }

      // api只支援一次傳一個檔，要用迴圈處理
      if (len > 0) {
        this.filesWip += len;
        if (!this.state.fileWorkInProgress) this.setState({ fileWorkInProgress: true });

        fileData.append('type', 'Sales_Case');

        // do not make functions in a loop;
        let printRes = (res, uploadedFileName, uploadedFileType) => {
          this.filesWip -= 1;
          if (this.filesWip < 1) {
            this.setState({ fileWorkInProgress: false });

            if (this.uploadedFiles.length) {
              // 清除檔案上傳相關狀態
              this.uploadedFiles = [];
              this.setState({ clearUploadedFileLocal: true });

              // 上傳檔案轉為下載狀態
              this.handlers.loadItemData(fileId || this.props.params.caseId, true);
            }

            if (this.state.deletedDownloadedFiles.length) {
              // 清除刪除紀錄
              this.setState({ deletedDownloadedFiles: [] });
            }

            // 新增情境時routing
            if (isNew) {
              // 在客戶資訊底下不會有router傳入
              if (this.props.router) {
                this.props.router.replace(`/salesky/sales-cases/${fileId}`);
              }

              if (this.state.editMode === 'Copy') {
                this.setState({
                  editMode: 'View',
                  onCopy: false
                });
              }
            } else {
              this.props.closeModal();
            }
          }
        };

        for (let i = 0; i < len; i++) {
          let value = "", uploadedFileName, uploadedFileType;
          if (isUpload) {
            value = this.uploadedFiles[i];
            uploadedFileName = value.name;
            uploadedFileType = value.type;
          } else {
            let fileName = this.state.deletedDownloadedFiles[i].file_name,
              backslashInd = fileName.lastIndexOf('/'),
              dotInd = fileName.lastIndexOf('.'),
              fileId = fileName.slice(backslashInd + 1, dotInd);

            value = fileId;
          }

          fileData.append(requiredField, value);
          custJqAjax({
            type: 'POST',
            url: `/api/${apiType}_SaleSky_File${apiKeyWord}.php`,
            data: fileData,
            processData: false,
            contentType: false,
            complete: res => { printRes(res, uploadedFileName, uploadedFileType); }
          });
        }
      }
    };

    // 控制檔案上傳進度用
    this.filesWip = 0;

    // ======================


    // setTimeout Id
    this.timer = "";


    this.state = {
      // 正式 ===
      case_owner_name: '',
      caseCreateDate: moment(),
      quoteDay: null,
      dealDay: null,
      companyId: '',
      // dpmId: '',
      dpmName: '',
      contactId: '',
      address: '',
      tel: '',
      fax: '',
      mobilePhone: '',
      email: '',
      currentStatus: '',
      currentStatusName: '',
      probability: '',
      probabilityName: '',
      cusSource: '',
      caseType: '',
      caseTypeName: '',
      remindDay: null,
      remindPeriod: '',
      expectedPrice: '',
      activeDays: 30,
      purchaseStatus: '',
      purchaseStatusName: '',
      paymentType: '',
      caseCurrency: '',
      caseProductDescription: '',
      negotiation: '',
      competitor: '',
      notes: '',
      // ===
      // item
      // itemId: '',
      // itemName: '',
      // deliveryNumber: '',
      orderNumber: '',
      deliveryDay: null,
      deliveryHour: '',
      deliveryMinute: '',
      arrivalDay: null,
      arrivalHour: '',
      arrivalMinute: '',
      installDay: null,
      installHour: '',
      installMinute: '',
      warrantyDay: null,
      warrantyHour: '',
      warrantyMinute: '',
      optsContact: [],
      modelId: '',
      modelName: '',
      serialNumber: '',
      amount: '',
      bomNumber: '',
      // shipping list
      shippingList: { loaded: false, data: [] },
      // file crud 相關 ====================
      downloadedFiles: [],
      downloadedImgs: [],
      downloadedPDFs: [],
      downloadedVideos: [],
      previewsImg: [],
      previewsPDF: [],
      previewsVideo: [],
      deletedDownloadedFiles: [],
      fileWorkInProgress: false, // 控制檔案上傳進度用
      forceUpdate: true,
      clearUploadedFileLocal: false,
      // ====================
      // common
      btnSaveDisable: true,
      btnDeleteDisable: true,
      onEdit: false,
      onCopy: false,
      editMode: "View"
    };
  }
  componentDidMount() {
    // 調整特定封裝內部元件css
    // $('#modal-product .modal-lg .modal-content:first-child').css({"min-width": '1024px'});
    $('#modal-product .modal-lg').css({ "min-width": '1024px' });

    const {
      optsCompany,
    } = this.props;

    if ((this.props.params && this.props.params.caseId) || this.props.selectedItemId) {
      this.handlers.changeItem();
    } else {
      // document.getElementById('deliveryNumber').focus();

      // under customer info ===
      this.funcs.setDefaultCompany(optsCompany);
      // ===

      this.setState({
        shippingList: {
          loaded: true,
          data: []
        },
        // 新增狀況下預設值為當日
        // caseCreateDate: moment()
      });
    }

    // 只有公司選項在這邊抓是因為get table資料時已有公司名稱，不用提早抓來mapping
    if (optsCompany.length === 0) {
      this.props.loadOptions('company', this.funcs.setDefaultCompany);
    }

    if (!this.props.productProps.productSortedData._data) {
      this.funcs.loadOptsModel();
    } else if (this.props.optsModel.length === 0) {
      this.props.parentStateHandler({
        states: 'optsModel',
        newValues: optsGeneratorCommon(this.props.productProps.productOrinData, ['value', 'label'], ['id', 'name'])
      });
    }

  }

  componentDidUpdate(prevProps, prevState) {
    // 資料驗證ok才可送出
    if (this.state.companyId === '' || this.state.currentStatus === '') {
      if (!this.state.btnSaveDisable) this.setState({ btnSaveDisable: true });
    } else if (this.state.btnSaveDisable) {
      this.setState({ btnSaveDisable: false });
    }
  }

  componentWillUnmount() {
    this.props.propsPackageFromSkyFamily.ajaxAborter(this.ajaxsWip);
    clearTimeout(this.timer);
  }

  render() {
    const { languageData, languageCode } = window.myConsts;

    const props = this.props, state = this.state, handlers = this.handlers,
      {
        optsCaseStatus,
        optsCaseType,
        optsCaseProbability,
        optsCaseSource,
        optsCasePayment,
        optsCaseRemindCyc,
        optsCasePurchmentStatus,
        optsCaseCurrency
      } = props;

    let saveBtn = "",
      deleteBtn = "",
      editable = 0,
      modeBtns = "",
      itemId = "",
      pagerUd = "",
      saveBtnText = state.fileWorkInProgress ? '檔案上傳中...' : '儲存';

    if (state.editMode !== "Copy") {
      if (props.params) itemId = props.params.caseId;
      else if (props.selectedItemId) itemId = props.selectedItemId;
    }

    if (state.editMode !== "View" || !itemId) {
      saveBtn = (
        <Button disabled={state.btnSaveDisable}
          onClick={() => { handlers.saveItem(state.onEdit ? 1 : 0) }}
          style={{ float: 'right', marginLeft: 5, position: "relative", zIndex: "3" }}>
          {saveBtnText}
        </Button>
      );
      editable = 1;
    } else {

      // 報表情況下唯讀
      if (props.viewOnly) {
        modeBtns = null;
      } else {
        modeBtns = (
          <span>
            <Button
              onClick={handlers.onCopyClick}
              style={{ float: 'right', marginLeft: 5, position: "relative", zIndex: "3" }}>
              複製
            </Button>
            <Button
              onClick={handlers.onEditClick}
              style={{ float: 'right', marginLeft: 5, position: "relative", zIndex: "3" }}>
              編輯
            </Button>
          </span>
        );
      }

      let disablePreviousBtn = false,
        disableNextBtn = false;

      if (props.filteredSortedData.getSize) {
        const selectedRowIndex = handlers.rowIndexCheck(true),
          max = props.filteredSortedData.getSize();

        disablePreviousBtn = (selectedRowIndex === 0);
        disableNextBtn = (selectedRowIndex === (max - 1));
      }

      pagerUd = <PagerUd style={{ position: "absolute", width: "100%", marginTop: 0, marginBottom: 0, marginLeft: -15, fontSize: 14, padding: "1px 0" }}
        onPreviousClick={handlers.onPreviousClick}
        onNextClick={handlers.onNextClick}
        disablePreviousBtn={disablePreviousBtn}
        disableNextBtn={disableNextBtn} />;
    }

    deleteBtn = state.onEdit ?
      <DeleteBtnWithConfirm
        style={{ float: "right", marginLeft: 5, position: "relative", zIndex: "3" }}
        onClick={handlers.deleteItem} />
      : "";

    const { previewsImg, previewsPDF, previewsVideo } = state,
      downloadedFilesPreview = { previewsImg, previewsPDF, previewsVideo };

    // const
    // tempOptsStatus = [
    //   {value: '1', label: "10％ 有興趣"},
    //   {value: '2', label: "30％ 產品說明簡報"},
    //   {value: '3', label: "50％ 確認需求"},
    //   {value: '4', label: "60％ 提供報價"},
    //   {value: '5', label: "70％ 預算符合"},
    //   {value: '6', label: "90％ 收到訂單"},
    //   {value: '7', label: "100％ 收到訂金"},
    //   {value: '8', label: "C 案件取消"},
    //   {value: '9', label: "L 輸給競爭對手"}
    // ],
    // tempOptsCaseType = [
    //   {value: '0', label: "直銷"},
    //   {value: '1', label: "經銷"},
    //   {value: '2', label: "報備"}
    // ],
    // tempOptsPurchaseStatus = [
    //   {value: '0', label: "有預算"},
    //   {value: '1', label: "提出申請"},
    //   {value: '2', label: "進入採購流程"},
    //   {value: '3', label: "開標議價階段"},
    //   {value: '4', label: "流標"},
    //   {value: '5', label: "下單"}
    // ],
    // tempOptsPaymentType = [
    //   {value: '0', label: "現金"},
    //   {value: '1', label: "期票"},
    //   {value: '2', label: "匯款"}
    // ],
    // tempOptsRemindPeriod = [
    //   {value: '0', label: "每週一次"},
    //   {value: '1', label: "二週一次"},
    //   {value: '2', label: "三週一次"},
    //   {value: '3', label: "一個月一次"}
    // ],
    // tempOptsDpm = [
    //   {value: "0", label: "業務部"},
    //   {value: "1", label: "財務部"},
    //   {value: "2", label: "設計"},
    //   {value: "3", label: "管理部"}
    // ],
    // tempOptsProbability = [
    //   {value: '1', label: "1%"},
    //   {value: '2', label: "5%"},
    //   {value: '3', label: "25%"},
    //   {value: '4', label: "50%"},
    // ];
    // tempOptsCusSource = [
    //   {value: '0', label: "陌生拜訪"},
    //   {value: '1', label: "舊有客戶"},
    //   {value: '2', label: "客戶介紹"},
    //   {value: '3', label: "同行介紹統包"},
    //   {value: '4', label: "電子報"},
    //   {value: '5', label: "網頁"},
    //   {value: '6', label: "研討會"},
    //   {value: '7', label: "原廠提供"},
    //   {value: '8', label: "其他"},
    // ];

    return (
      <Modal id="modal-product" style={{ overflow: 'auto' }} keyboard={false} backdrop="static" show={true} onHide={props.closeModal} bsSize="large">
        <Modal.Header>
          <Modal.Title>
            <span style={{ padding: "6px 0px", height: 34, lineHeight: '34px' }}>
              {
                itemId ?
                  <span style={{ float: "left" }}>
                    <span style={{ color: "rgba(0, 0, 200, .7" }}>{state.editMode}</span> Mode
                </span> :
                  <span>
                    New Case
                </span>
              }
            </span>
            <Button onClick={props.closeModal} style={{ float: 'right', marginLeft: 5, position: "relative", zIndex: "3" }}>取消</Button>
            {saveBtn}
            {modeBtns}
            {deleteBtn}
            {pagerUd}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>

          <Row>
            <Col sm={12}>
              <FormGroup controlId="creator">
                <ControlLabel style={{ marginBottom: 0, fontWeight: 'bold' }}>建立者 <span style={{ fontWeight: 'normal', marginBottom: 0 }}>{state.case_owner_name || props.userName}</span></ControlLabel>
              </FormGroup>
            </Col>
          </Row>

          <Row>
            <Col sm={12}>
              <div style={{ fontWeight: "bold", marginBottom: 5 }}>基本資料</div>
            </Col>
            <Col sm={12}>
              <Well>
                <Row>
                  {/* <Col sm={6}>
                    <FormGroup controlId="deliveryNumber"
                      validationState={state.caseCreateDate ? null : 'error'}>
                      <ControlLabel style={{fontWeight: 'bold'}}>個案名稱</ControlLabel>
                      <FormControl
                        // disabled={state.onCopy ? false : itemId}
                        disabled={!editable}
                        type='text'
                        onChange={handlers.textInputOnChange}
                        value={state.deliveryNumber}
                        style={{height: 36}} />
                    </FormGroup>
                  </Col> */}

                  <Col sm={6}>
                    <FormGroup controlId="tel">
                      <ControlLabel style={{ fontWeight: 'bold' }}>建立日期</ControlLabel>
                      <FormControl
                        disabled={true}
                        type='text'
                        // onChange={handlers.textInputOnChange}
                        value={state.caseCreateDate.format("YYYY/MM/DD")}
                        style={{ height: 36 }} />
                    </FormGroup>
                  </Col>

                  <DropDownMenu
                    required={true}
                    labelStyle={{ fontWeight: 'bold' }}
                    sm={6}
                    label='公司名稱'
                    options={props.optsCompany}
                    disabled={!editable}
                    onChange={handlers.dropDownOnChange}
                    value={state.companyId}
                    stateName='companyId' />

                  {/* <DropDownMenu
                    labelStyle={{fontWeight: 'bold'}}
                    sm={6}
                    label='部門'
                    options={tempOptsDpm || state.optsContact}
                    // disabled={editable ? !state.companyId : true}
                    disabled={!editable}
                    onChange={handlers.dropDownOnChange}
                    value={state.dpmId}
                    stateName='dpmId' /> */}

                  <DropDownMenu
                    labelStyle={{ fontWeight: 'bold' }}
                    sm={6}
                    label='聯絡人'
                    options={state.optsContact}
                    disabled={editable ? !state.companyId : true}
                    onChange={handlers.dropDownOnChange}
                    value={state.contactId}
                    stateName='contactId' />

                  <Col sm={6}>
                    <FormGroup controlId="dpmName">
                      <ControlLabel style={{ fontWeight: 'bold' }}>部門</ControlLabel>
                      <FormControl
                        disabled={true}
                        type='text'
                        onChange={handlers.textInputOnChange}
                        value={state.dpmName}
                        style={{ height: 36 }} />
                    </FormGroup>
                  </Col>

                  <Col sm={6}>
                    <FormGroup controlId="tel">
                      <ControlLabel style={{ fontWeight: 'bold' }}>聯絡電話</ControlLabel>
                      <FormControl
                        disabled={true}
                        type='text'
                        onChange={handlers.textInputOnChange}
                        value={state.tel}
                        style={{ height: 36 }} />
                    </FormGroup>
                  </Col>

                  <Col sm={6}>
                    <FormGroup controlId="mobilePhone">
                      <ControlLabel style={{ fontWeight: 'bold' }}>行動電話</ControlLabel>
                      <FormControl
                        disabled={true}
                        type='text'
                        onChange={handlers.textInputOnChange}
                        value={state.mobilePhone}
                        style={{ height: 36 }} />
                    </FormGroup>
                  </Col>

                  <Col sm={6}>
                    <FormGroup controlId="fax">
                      <ControlLabel style={{ fontWeight: 'bold' }}>傳真</ControlLabel>
                      <FormControl
                        disabled={true}
                        type='text'
                        onChange={handlers.textInputOnChange}
                        value={state.fax}
                        style={{ height: 36 }} />
                    </FormGroup>
                  </Col>

                  <Col sm={6}>
                    <FormGroup controlId="email">
                      <ControlLabel style={{ fontWeight: 'bold' }}>電子郵件</ControlLabel>
                      <FormControl
                        disabled={true}
                        type='text'
                        onChange={handlers.textInputOnChange}
                        value={state.email}
                        style={{ height: 36 }} />
                    </FormGroup>
                  </Col>
                </Row>
              </Well>
            </Col>

            {/* 個案狀態 */}

            <Col sm={12}>
              <div style={{ fontWeight: "bold", marginBottom: 5 }}>個案狀態</div>
            </Col>
            <Col sm={12}>
              <Well>
                <Row>

                  <DropDownMenu
                    required={true}
                    labelStyle={{ fontWeight: 'bold' }}
                    sm={6}
                    label='目前狀態'
                    options={optsCaseStatus}
                    disabled={!editable}
                    onChange={handlers.dropDownOnChange}
                    value={state.currentStatus}
                    stateName='currentStatus' />

                  <DropDownMenu
                    labelStyle={{ fontWeight: 'bold' }}
                    sm={6}
                    label='個案分類'
                    options={optsCaseType}
                    disabled={!editable}
                    onChange={handlers.dropDownOnChange}
                    value={state.caseType}
                    stateName='caseType' />

                  <DropDownMenu
                    labelStyle={{ fontWeight: 'bold' }}
                    sm={6}
                    label='結案機率'
                    options={optsCaseProbability}
                    disabled={!editable}
                    onChange={handlers.dropDownOnChange}
                    value={state.probability}
                    stateName='probability' />

                  <DropDownMenu
                    labelStyle={{ fontWeight: 'bold' }}
                    sm={6}
                    label='客戶來源'
                    options={optsCaseSource}
                    disabled={!editable}
                    onChange={handlers.dropDownOnChange}
                    value={state.cusSource}
                    stateName='cusSource' />

                  <Col sm={12}>
                    <FormGroup controlId="caseProductDescription">
                      <ControlLabel style={{ fontWeight: 'bold' }}>產品描述</ControlLabel>
                      <FormControl
                        componentClass="textarea"
                        placeholder=""
                        disabled={!editable}
                        type='text'
                        onChange={handlers.textInputOnChange}
                        value={state.caseProductDescription}
                        style={{ height: 122 }} />
                    </FormGroup>
                  </Col>

                  <DayPicker
                    labelFontWeight="bold"
                    sm={6}
                    disabled={!editable}
                    outerLabel="報價日期"
                    onChange={handlers.dateOnChange}
                    dayStateName="quoteDay"
                    dayValue={state.quoteDay} />

                  <Col sm={6}>
                    <FormGroup controlId="activeDays">
                      <ControlLabel style={{ fontWeight: 'bold' }}>有效天數</ControlLabel>
                      <FormControl
                        disabled={!editable}
                        type='text'
                        onChange={handlers.textInputOnChange}
                        value={state.activeDays}
                        style={{ height: 36 }} />
                    </FormGroup>
                  </Col>

                  <DayPicker
                    labelFontWeight="bold"
                    sm={6}
                    disabled={!editable}
                    outerLabel="預計成交日"
                    onChange={handlers.dateOnChange}
                    dayStateName="dealDay"
                    dayValue={state.dealDay} />

                  <DropDownMenu
                    labelStyle={{ fontWeight: 'bold' }}
                    sm={6}
                    label='幣別'
                    options={optsCaseCurrency}
                    // disabled={editable ? !state.companyId : true}
                    disabled={!editable}
                    onChange={handlers.dropDownOnChange}
                    value={state.caseCurrency}
                    stateName='caseCurrency' />

                  <DropDownMenu
                    labelStyle={{ fontWeight: 'bold' }}
                    sm={6}
                    label='付款方式'
                    options={optsCasePayment}
                    // disabled={editable ? !state.companyId : true}
                    disabled={!editable}
                    onChange={handlers.dropDownOnChange}
                    value={state.paymentType}
                    stateName='paymentType' />

                  <Col sm={6}>
                    <FormGroup controlId="expectedPrice">
                      <ControlLabel style={{ fontWeight: 'bold' }}>預計成交價</ControlLabel>
                      <FormControl
                        disabled={!editable}
                        type='text'
                        onChange={handlers.textInputOnChange}
                        value={state.expectedPrice}
                        style={{ height: 36 }} />
                    </FormGroup>
                  </Col>

                  <DayPicker
                    labelFontWeight="bold"
                    sm={6}
                    disabled={!editable}
                    outerLabel="下次提醒"
                    onChange={handlers.dateOnChange}
                    dayStateName="remindDay"
                    dayValue={state.remindDay} />

                  <DropDownMenu
                    labelStyle={{ fontWeight: 'bold' }}
                    sm={6}
                    label='週期通知'
                    options={optsCaseRemindCyc}
                    // disabled={editable ? !state.companyId : true}
                    disabled={!editable}
                    onChange={handlers.dropDownOnChange}
                    value={state.remindPeriod}
                    stateName='remindPeriod' />

                  <DropDownMenu
                    labelStyle={{ fontWeight: 'bold' }}
                    sm={6}
                    label='採購狀態'
                    options={optsCasePurchmentStatus}
                    // disabled={editable ? !state.companyId : true}
                    disabled={!editable}
                    onChange={handlers.dropDownOnChange}
                    value={state.purchaseStatus}
                    stateName='purchaseStatus' />


                  <Col sm={6}>
                    <FormGroup controlId="competitor">
                      <ControlLabel style={{ fontWeight: 'bold' }}>競爭者</ControlLabel>
                      <FormControl
                        disabled={!editable}
                        type='text'
                        onChange={handlers.textInputOnChange}
                        value={state.competitor}
                        style={{ height: 36 }} />
                    </FormGroup>
                  </Col>

                  <Col sm={12}>
                    <FormGroup controlId="negotiation">
                      <ControlLabel style={{ fontWeight: 'bold' }}>議價對策</ControlLabel>
                      <FormControl
                        componentClass="textarea"
                        placeholder=""
                        disabled={!editable}
                        type='text'
                        onChange={handlers.textInputOnChange}
                        value={state.negotiation}
                        style={{ height: 122 }} />
                    </FormGroup>
                  </Col>

                  <Col sm={12}>
                    <FormGroup controlId="notes">
                      <ControlLabel style={{ fontWeight: 'bold' }}>備註</ControlLabel>
                      <FormControl
                        componentClass="textarea"
                        placeholder=""
                        disabled={!editable}
                        type='text'
                        onChange={handlers.textInputOnChange}
                        value={state.notes}
                        style={{ height: 122 }} />
                    </FormGroup>
                  </Col>

                </Row>
              </Well>
            </Col>
          </Row>



          <Row>
            <Col sm={12}>
              <div style={{ fontWeight: "bold", marginBottom: 5 }}>附件</div>
            </Col>
            <Col sm={12}>
              <Well style={{ margin: 0 }}>
                <FileDropAreaCt
                  parentStateHandler={this.parentStateHandler}
                  disabled={!editable}
                  uploadedFiles={this.uploadedFiles}
                  downloadedFilesPreview={downloadedFilesPreview}
                  clearUploadedFileLocal={state.clearUploadedFileLocal} />
              </Well>
            </Col>
          </Row>

          <hr />

          <ShippingListCt
            viewOnly={props.viewOnly}
            parentStateHandler={this.parentStateHandler}
            deliveryNumber={itemId}
            languageCode={languageCode}
            languageData={languageData}
            shippingList={state.shippingList} />

        </Modal.Body>
        <Modal.Footer>
          {pagerUd}
          <Button onClick={props.closeModal} style={{ float: 'right', marginLeft: 5, position: "relative", zIndex: "3" }}>取消</Button>
          {saveBtn}
          {deleteBtn}
        </Modal.Footer>
      </Modal>
    );
  }
}


// WEBPACK FOOTER //
// ./src/salesky/routes/salesCases/SalesCasesModalCt.jsx